<b3-drawer
  [open]="isOpen"
  size="sm"
  overlay
  (b3-close)="close()"
  (b3-back)="close()">
  <b3-drawer-header
    heading="Filtrar"
    show-back
    back-aria-label="Fechar filtros">
  </b3-drawer-header>

  <b3-drawer-body>
    <form class="filter-form" [formGroup]="formFilter">
      <div class="filter-section">
        <p class="filter-section__title">Período das operações</p>
        <ng-container *ngFor="let resetKey of [datepickerResetKey]; trackBy: trackDatepickerResetKey">
          <div class="filter-section__row">
            <div class="filter-field">
              <b3-datepicker
                inputId="initialDate"
                label="Data inicial"
                formControlName="initialDate"
                background="grey"
                placeholder="DD/MM/AAAA"
                locale="pt-BR"
                [max]="maxInitialDateIso"
                [error]="invalidPeriodDate"
                (b3-change)="onInitialDateChange($event)">
              </b3-datepicker>
            </div>
            <div class="filter-field">
              <b3-datepicker
                inputId="finalDate"
                label="Data final"
                formControlName="finalDate"
                background="grey"
                placeholder="DD/MM/AAAA"
                locale="pt-BR"
                popoverLeftOffset="-110px"
                [min]="minFinalDateIso"
                [error]="invalidPeriodDate"
                (b3-change)="onFinalDateChange($event)">
              </b3-datepicker>
            </div>
          </div>
        </ng-container>
      </div>

      <div class="filter-section__row">
        <div class="filter-field">
          <b3-input-text
            formControlName="carbonCreditCode"
            inputId="carbonCreditCode"
            label="Código IF"
            placeholder="Código IF"
            background="grey"
            mask="instrument">
          </b3-input-text>
        </div>
        <div class="filter-field">
          <b3-input-text
            formControlName="code"
            inputId="code"
            label="Nº de controle"
            placeholder="Nº de controle"
            background="grey"
            mask="integer">
          </b3-input-text>
        </div>
      </div>

      <div class="filter-field">
        <b3-input-select
          formControlName="type"
          inputId="operation-type-select"
          label="Tipo de operação"
          placeholder="Tipo de operação"
          background="grey"
          maxHeight="280px"
          [options]="operationType">
          <b3-input-select-option
            *ngFor="let item of operationType; let i = index"
            [attr.value]="item.inputId"
            [attr.index]="i"
            [id]="'operation-type-option-' + item.inputId">
            {{ item.label }}
          </b3-input-select-option>
        </b3-input-select>
      </div>

      <div class="filter-section__row">
        <div class="filter-field">
          <b3-input-text
            formControlName="purchaseAccount"
            inputId="purchaseAccount"
            label="Conta registradora"
            background="grey"
            mask="account"
            placeholder="00000.40-0">
          </b3-input-text>
        </div>
        <div class="filter-field">
          <b3-input-text
            formControlName="holderAccount"
            inputId="holderAccount"
            label="Conta detentora"
            background="grey"
            mask="account"
            placeholder="00000.00-0">
          </b3-input-text>
        </div>
      </div>

      <div class="filter-actions">
        <b3-button type="button" variant="ghost" tone="default" (b3-click)="cleanForm()">
          <b3-icon name="backspace" size="md"></b3-icon>
          Limpar
        </b3-button>
        <b3-button
          type="button"
          variant="filled"
          tone="default"
          [disabled]="invalidPeriodDate"
          (b3-click)="filter()">
          <b3-icon name="filter_list" size="md" tone="on-brand"></b3-icon>
          Filtrar
        </b3-button>
      </div>
    </form>
  </b3-drawer-body>
</b3-drawer>
